import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="page-hdr">
      <div class="page-hdr__left">
        @if (backLabel && backRoute) {
          <a [routerLink]="backRoute" class="page-hdr__back">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>
            {{ backLabel }}
          </a>
        }
        <h1 class="page-hdr__title">{{ title }}</h1>
        @if (subtitle) {
          <p class="page-hdr__subtitle">{{ subtitle }}</p>
        }
      </div>
      @if (showAction) {
        <div class="page-hdr__actions">
          <button class="btn btn--primary" (click)="action.emit()">{{ actionLabel }}</button>
        </div>
      }
    </div>
  `,
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() showAction = false;
  @Input() actionLabel = 'Novo';
  @Input() backLabel = '';
  @Input() backRoute: string | string[] | null = null;
  @Output() action = new EventEmitter<void>();
}
